import api from '@/lib/api';

// ─── Portfolio rollup contract ──────────────────────────────────────────────
// Mirrors the backend PortfolioService response (Hotel Groups F2). KPIs are
// bucketed PER CURRENCY and are NEVER blind-summed across currencies.

export interface PortfolioCurrencyBucket {
  currency: string;
  revenue: number;
  adr: number;
  revPar: number;
  occupancyRate: number;
  arrivalsToday: number;
  departuresToday: number;
  /** Live, with-data properties that fed this bucket's weighting. */
  propertyCount: number;
}

export interface PortfolioPropertyRow {
  id: string;
  name: string;
  /** 'live' = review_status APPROVED; anything else = 'draft'. */
  state: 'live' | 'draft';
  currency: string;
  occupancyRate: number;
  arrivals: number;
  departures: number;
  revenueMtd: number;
  adr: number;
  revPar: number;
}

export interface PortfolioRollup {
  propertyCount: number;
  live: number;
  draft: number;
  currencyBuckets: PortfolioCurrencyBucket[];
  /** Properties left out of currency-bucket weighting (draft or no room-nights). */
  excluded: { draftOrNoData: number };
  properties: PortfolioPropertyRow[];
  meta: { total: number; page: number; limit: number; totalPages: number };
}

export interface PortfolioQuery {
  from: string;
  to: string;
  page?: number;
  limit?: number;
  /** Narrows only the drill-down table to a single currency bucket. */
  currency?: string;
}

export async function fetchPortfolio(query: PortfolioQuery): Promise<PortfolioRollup> {
  const { data } = await api.get<PortfolioRollup>('/dashboard/portfolio', {
    params: query,
  });
  return data;
}
